ace.define("ace/snippets/text",["require","exports","module"],function(e,t,n){"use strict";t.snippetText=undefined,t.scope="text"})


//////////////////
// WEBPACK FOOTER
// ./~/ace-builds/src-min-noconflict/snippets/text.js
// module id = 468
// module chunks = 1